import React from 'react';
import styles from './css/Pricing.styl';

const Pricing = () => (
  <div className={styles.Pricing}>
    <div className={styles.Description}>
      <div className={styles.Title}>
        The average funeral{' '}
        <span className={styles.NoWrap}>
          costs{' '}
          <span style={{fontWeight: 'bold', color: '#006699'}}>$8,755</span>
          <span style={{fontSize: '24px', verticalAlign: 'top'}}> *</span>
        </span>
      </div>
      <div className={styles.Blurb}>
        Start planning today to settle your family&apos;s{' '}
        <span className={styles.NoWrap}>expenses ahead of time.</span>
      </div>
    </div>
    <div className={styles.Prices}>
      <ul className={styles.Averages}>
        <li>
          <span>Basic Service Fees</span>
          <span>$2,100</span>
        </li>
        <li>
          <span>Transfer of Remains</span>
          <span>$325</span>
        </li>
        <li>
          <span>Embalming</span>
          <span>$725</span>
        </li>
        <li>
          <span>Viewing</span>
          <span>$425</span>
        </li>
        <li>
          <span>Funeral Ceremony</span>
          <span>$500</span>
        </li>
        <li>
          <span>Burial Casket</span>
          <span>$2,400</span>
        </li>
        <li>
          <span>Other Preparations</span>
          <span>$250</span>
        </li>
        <li className={styles.Totals}>
          <span>Total</span>
          <span>$8,755</span>
        </li>
      </ul>
      <div className={styles.Source}>
        * Source:&nbsp;
        <a href="https://www.nfda.org/news/statistics">
          www.nfda.org/news/statistics
        </a>
      </div>
    </div>
  </div>
);

export default Pricing;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/Pricing/index.js